// 2023-11-01 - Code moved from formsviewer.domain.js

// ============
//  RuleAction
// ============
// Base type for all rule actions
function RuleAction(type) {
    this.addProperties({ actionType: type });
}

RuleAction.prototype.addProperties = function (props) {
    Object.assign(this, props);
};

// =================
//  AssignmentAction
// =================
export function AssignmentAction(targetField, expression) {
    this.addProperties({
        target: targetField,
        expression: expression,
    });
}
AssignmentAction.type = 'assignment';
AssignmentAction.prototype = new RuleAction(AssignmentAction.type);

export function ChangeAdapterAction(adapter, expression, adapterProperty) {
    this.addProperties({
        adapterName: adapter,
        expression: expression,
        adapterProperty: adapterProperty,
    });
}
ChangeAdapterAction.type = 'changeAdapter';
ChangeAdapterAction.prototype = new RuleAction(ChangeAdapterAction.type);

export function QueryAction(adapter) {
    this.addProperties({ adapterName: adapter });
}
QueryAction.type = 'query';
QueryAction.prototype = new RuleAction(QueryAction.type);

export function SubmitAction(adapter) {
    this.addProperties({ adapterName: adapter });
}
SubmitAction.type = 'submit';
SubmitAction.prototype = new RuleAction(SubmitAction.type);

// ==================
//  SwitchViewAction
// ==================
export const ACTION_TYPE_SWITCHVIEW = 'switchView';

export const switchViewAction = (viewName) => ({
    actionType: ACTION_TYPE_SWITCHVIEW,
    view: viewName,
});

// ===================
// CloseDocumentAction
// ===================
export function CloseDocumentAction(promptSave) {
    this.getPromptSave = function () {
        return promptSave;
    };
}
CloseDocumentAction.type = 'closeDocument';
CloseDocumentAction.prototype = new RuleAction(CloseDocumentAction.type);

// ==========
// ExitAction
// ==========
export function ExitAction() {}
ExitAction.type = 'exitRuleSet';
ExitAction.prototype = new RuleAction(ExitAction.type);

// ======================
// DialogExpressionAction
// ======================
export function DialogExpressionAction(expression) {
    this.addProperties({ expression: expression });
}
DialogExpressionAction.type = 'dialogExpression';
DialogExpressionAction.prototype = new RuleAction(DialogExpressionAction.type);

// ======================
// DialogExpressionAction
// ======================
export function DialogMessageAction(message) {
    this.addProperties({ message: message });
}
DialogMessageAction.type = 'dialogMessage';
DialogMessageAction.prototype = new RuleAction(DialogMessageAction.type);
